<template>
  <div id="large-auth">
    <div id="auth-column">
      <div id="auth-container">
        <div id="choose-container">
          <div id="box" :class="{ 'sign-up': !isLogin }" />
          <div class="choose-item">
            <p>Have an account?</p>
            <BushelBtn variant="light" :ripple="false" outline @click="$emit('toggleLoginView')"> Log In </BushelBtn>
          </div>
          <div class="choose-item">
            <p>Don't have an account?</p>
            <BushelBtn id="register_toggle_btn" dusk="register-toggle-btn" variant="light" :ripple="false" outline @click="$emit('toggleLoginView')">
              Sign Up
            </BushelBtn>
          </div>
        </div>
        <div id="card-container" :class="{ 'sign-up': !isLogin }">
          <div class="header-container">
            <img
              id="header-logo"
              :src="industry == 'cannabis' ? '/img/logos/apex-logo.png' : '/img/logos/bushel-logo.png'"
              :alt="industry == 'cannabis' ? 'Apex Logo' : 'Bushel44 Logo'"
            />
          </div>
          <div class="body-container" :class="{ 'sign-up': !isLogin }">
            <div v-if="isLogin" class="segment log-in">
              <Login :form-data="formData" @input="$emit('input', $event)" />
            </div>
            <div v-else class="segment sign-up">
              <Register
                :form-data="formData"
                :countries="countries"
                :joining-company-name="joiningCompanyName"
                :states="states"
                :subscription-types="subscriptionTypes"
                :create-brand="createBrand"
                @input="$emit('input', $event)"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
    <div id="banner-column">
      <h1>Welcome to</h1>
      <img
        :src="industry == 'cannabis' ? '/img/logos/apex-sidebar-logo.png' : '/img/logos/bushel-sidebar-logo.png'"
        :alt="industry == 'cannabis' ? 'Apex Logo' : 'Bushel44 Logo'"
      />
      <h3 class="text-white p-5">Get started by creating an account today.</h3>
      <p class="text-white" style="margin-top: 40px">
        Questions? Contact us at
        <br />
        <a class="text-white" :href="industry == 'cannabis' ? 'mailto:support@apextrading.com' : 'mailto:support@bushel44.com'">
          <span v-if="industry == 'cannabis'">support@apextrading.com</span>
          <span v-if="industry == 'hemp'">support@bushel44.com</span>
        </a>
        <br />
        or
      </p>

      <button onclick="_chatlio.showOrHide();" data-chatlio-widget-button class="btn btn-success">Live Chat Now</button>
    </div>
  </div>
</template>

<script>
import Login from "./Login.vue";
import Register from "./Register.vue";

export default {
  components: {
    Login,
    Register,
  },
  props: {
    formData: { type: Object, required: true },
    countries: { type: Array, required: true },
    states: { type: Array, required: true },
    joiningCompanyName: { type: String },
    subscriptionTypes: { type: Array, required: true },
    createBrand: { type: Boolean, default: false },
  },
  emits: ["input", "toggleLoginView"],
  data() {
    return {
      industry: APP_INDUSTRY,
      isShowingLogin: true,
      showPassword: false,
      acceptTerms: false,
      showTerms: false,
      showPasswordReset: false,
      email: "",
      password: "",
      passwordConfirm: "",
      valid: false,
      name: "",
      phone: "",
    };
  },
  computed: {
    isLogin() {
      return this.formData.isShowingLogin;
    },
  },
};
</script>

<style scoped lang="scss">
@import "@sass/_variables.scss";

#large-auth {
  display: grid;
  grid-template-columns: 1fr minmax(27rem, 30%);
  width: 100vw;
  height: 100vh;

  #auth-column {
    display: flex;
    justify-content: center;
    align-items: center;

    #auth-container {
      display: grid;
      position: relative;
      align-items: center;
      margin: 0 0.5rem;

      & > * {
        grid-area: 1 / 1;
      }

      #choose-container {
        display: grid;
        grid-template-columns: 1fr 1fr;
        position: relative;
        width: 100%;
        min-width: 45rem;
        height: 22rem;
        border-radius: 1rem;
        background: #374156;
        color: white;

        #box {
          position: absolute;
          left: 0;
          top: 0;
          width: 100%;
          height: 100%;
          overflow: hidden;

          &::before,
          &::after {
            position: absolute;
            content: " ";
            top: 15%;
            left: 23%;
            width: calc(50% - 2rem);
            height: calc(100% - 3rem);
            background-color: darken($primary, 10%);
            transform: rotateX(52deg) rotateY(15deg) rotateZ(-38deg);
            transition: transform 0.5s;
            transition: all 500ms;
          }

          &::after {
            top: -3%;
            left: 13%;
            width: 50%;
            height: calc(100% - 10rem);
            background-color: lighten($primary, 10%);
          }

          &.sign-up {
            &::before {
              top: 23%;
              left: 29%;
              height: calc(100% - 5rem);
            }

            &::after {
              top: 5%;
              left: 26%;
              height: calc(100% - 7rem);
              width: calc(50% + 1rem);
            }
          }
        }

        .choose-item {
          display: flex;
          flex-direction: column;
          align-items: center;
          justify-content: center;
          z-index: 1;
        }
      }

      #card-container {
        z-index: 2;
        display: flex;
        position: inherit;
        flex-direction: column;
        left: 2rem;
        width: 51rem;
        max-width: calc(50% - 2rem);
        background: white;
        border-radius: 1rem;
        box-shadow: 0 0 15px 0 rgba(0, 0, 0, 0.2);
        // overflow-x: clip;
        transform: translateX(0%);
        transition: 500ms transform;

        &.sign-up {
          transform: translateX(100%);
        }

        .header-container {
          display: flex;
          justify-content: center;
          padding: 0.75rem;

          #header-logo {
            height: 2rem;
          }
        }

        .body-container {
          display: flex;
          // width: 200%;
          height: min-content;
          transform: translateX(0%);
          transition: 500ms transform;

          .segment {
            display: flex;
            justify-content: center;
            // width: 50%;
            width: 100%;
            padding: 1rem;
            transition: 500ms opacity;
            min-height: 22rem;

            &.log-in {
              opacity: 1;
              height: 100%;
            }
            &.sign-up {
              overflow: clip;
              height: 0px;
              opacity: 0;
            }
          }

          &.sign-up {
            // transform: translateX(-50%);

            .segment {
              &.log-in {
                overflow: clip;
                height: 0px;
                opacity: 0;
              }
              &.sign-up {
                overflow: visible;
                height: 100%;
                opacity: 1;
              }
            }
          }
        }
      }
    }
  }

  #banner-column {
    display: flex;
    flex-direction: column;
    align-items: center;
    padding-top: 5rem;
    text-align: center;
    background-image: url("/img/backgrounds/sidebar-bg.png");
    background-size: cover;
    background-repeat: no-repeat;
    background-position: top;
    background-attachment: unset;

    h1 {
      color: #fdfffc;
      font-family: "News Cycle", sans-serif;
    }

    img {
      width: 60%;
    }
  }

  @media (max-width: 1265px) {
    grid-template-columns: 1fr;

    #banner-column {
      display: none;
    }
  }
}
</style>
